import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon, CheckCircle2Icon } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'Sarah M.',
  service: 'Lawn Care & Maintenance',
  rating: 5,
  text: "Manny's has been maintaining our property for over a year now. They are always punctual, professional, and our lawn has never looked better. Highly recommend their weekly service!"
}, {
  id: 2,
  name: 'David L.',
  service: 'Hardscaping & Concrete',
  rating: 5,
  text: 'We hired them to pour a new concrete patio and install a gravel walkway. The attention to detail was incredible. They finished on time and left the site completely clean.'
}, {
  id: 3,
  name: 'Jennifer K.',
  service: 'Seasonal Cleanup',
  rating: 5,
  text: "After a huge storm, our yard was a mess. Manny's came out quickly, removed all the fallen branches, blew the roof, and restored everything perfectly. Lifesavers!"
}, {
  id: 4,
  name: 'Michael T.',
  service: 'Mulch & Flower Beds',
  rating: 5,
  text: 'They completely transformed our front yard. The new edging and fresh mulch make the house look brand new. Very reasonable pricing for the quality of work.'
}, {
  id: 5,
  name: 'Robert H.',
  service: 'Sod Installation',
  rating: 5,
  text: "Our old lawn was completely dead. Manny's removed it, prepped the soil, and laid new sod in just two days. It rooted perfectly and looks like a golf course now."
}, {
  id: 6,
  name: 'Amanda C.',
  service: 'General Landscaping',
  rating: 5,
  text: "Family-owned business that truly cares about their clients. They listen to what you want and deliver exactly that. I won't use anyone else for my landscaping needs."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Reviews() {
  return <section id="reviews" className="py-32 bg-tan relative overflow-hidden" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-174">
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-175">
              What Our Clients Say
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-forest mb-6 font-serif" data-id="element-176">
              Customer Reviews
            </h2>
            <div className="w-24 h-1.5 bg-gold mx-auto rounded-full mb-8" data-id="element-177"></div>

            {/* Overall Rating Summary */}
            <div className="flex flex-col items-center justify-center gap-3 mb-8" data-id="element-178">
              <div className="flex items-center gap-1" data-id="element-179">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 text-gold fill-gold" data-id="element-180" />)}
              </div>
              <p className="text-xl text-forest-dark font-semibold" data-id="element-181">
                5.0 Average Rating
              </p>
              <p className="text-gray-600 font-light" data-id="element-182">
                Based on 50+ verified reviews across Washington State
              </p>
            </div>
          </motion.div>
        </div>

        {/* Reviews Grid / Carousel */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="flex overflow-x-auto pb-8 -mx-4 px-4 md:mx-0 md:px-0 md:grid md:grid-cols-2 lg:grid-cols-3 gap-6 snap-x snap-mandatory md:snap-none hide-scrollbar" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-183">
          {reviews.map(review => <motion.div key={review.id} variants={cardVariants} className="min-w-[300px] md:min-w-0 w-full snap-center bg-white rounded-3xl p-8 shadow-lg border border-gray-100 relative group hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-184">
              {/* Decorative Quote Icon */}
              <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity duration-300" data-id="element-185">
                <QuoteIcon className="w-16 h-16 text-gold rotate-180" data-id="element-186" />
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1 mb-6" data-id="element-187">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-188" />)}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 text-lg leading-relaxed font-light mb-8 flex-grow relative z-10" data-id="element-189">
                "{review.text}"
              </p>

              {/* Customer Info */}
              <div className="mt-auto pt-6 border-t border-gray-100 flex items-center justify-between relative z-10" data-id="element-190">
                <div data-id="element-191">
                  <h4 className="font-bold text-forest text-lg" data-id="element-192">
                    {review.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-193">{review.service}</p>
                </div>
                <div className="flex items-center gap-1.5 bg-tan px-3 py-1.5 rounded-full" data-id="element-194">
                  <CheckCircle2Icon className="w-4 h-4 text-forest" data-id="element-195" />
                  <span className="text-xs font-semibold text-forest" data-id="element-196">
                    Verified
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}